import { useState } from 'react';
import { useRailsContext } from '~/single-page/contexts/RailsContext';
import AuthorizationClient from '~/single-page/api/AuthorizationClient';
import { toast } from 'react-toastify';

export const useAuth = () => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const { setFlash } = useRailsContext();

  const signIn = async (email, password) => {
    setLoading(true);
    setErrors({});
    
    try {
      const response = await AuthorizationClient.signIn({ email, password });
      const { status, data } = response.data;
      
      if (status.code === 200) {
        setFlash({ notice: status.message });
        
        if (data.roles && data.roles.includes('pending_approval')) {
          window.location.href = '/registration_status';
        } else {
          window.location.href = '/admin';
        }
      }
    } catch (error) {
      if (error.response?.data?.status?.code === 401) {
        setErrors({ email: error.response.data.status.message });
        toast.error(error.response.data.status.message);
      } else {
        toast.error('Erro ao tentar fazer login. Por favor, tente novamente.');
      }
    } finally {
      setLoading(false);
    }
  };

  const signOut = async () => {
    try {
      await AuthorizationClient.signOut();
      localStorage.clear();
      sessionStorage.clear();
    } catch (error) {
      toast.error('Erro ao processar logout.');
    }
  };

  return { signIn, signOut, loading, errors };
};
